// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__144ac","col":"CardReaderDesc_col__1cn7N","label":"CardReaderDesc_label__1tK_p"};